module.exports = __webpack_public_path__ + "static/media/Finnovex-Qatar-2023.8d744594.png";